/**
 * @generated SignedSource<<2d858cfc3f53950632807ad3db255e24>>
 * @relayHash 5a5995410266e6c9a8ce3a158e79c7ea
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a5995410266e6c9a8ce3a158e79c7ea

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deletePatientSocialSecurityNumberInput = {
  patientId: string;
};
export type useChDeletePatientSocialSecurityNumberMutation$variables = {
  input: Ch_deletePatientSocialSecurityNumberInput;
};
export type useChDeletePatientSocialSecurityNumberMutation$data = {
  readonly ch_deletePatientSocialSecurityNumber: {
    readonly ch_Patient: {
      readonly id: string;
      readonly socialSecurityNumber: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChDeletePatientSocialSecurityNumberMutation = {
  response: useChDeletePatientSocialSecurityNumberMutation$data;
  variables: useChDeletePatientSocialSecurityNumberMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_Patient",
  "kind": "LinkedField",
  "name": "ch_Patient",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialSecurityNumber",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeletePatientSocialSecurityNumberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePatientSocialSecurityNumberPayload",
        "kind": "LinkedField",
        "name": "ch_deletePatientSocialSecurityNumber",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeletePatientSocialSecurityNumberMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deletePatientSocialSecurityNumberPayload",
        "kind": "LinkedField",
        "name": "ch_deletePatientSocialSecurityNumber",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5a5995410266e6c9a8ce3a158e79c7ea",
    "metadata": {},
    "name": "useChDeletePatientSocialSecurityNumberMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4093b6a5a8a2f33cf75156a4758eed04";

export default node;
